import { create } from 'zustand';
import { useEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { useCustomMediaQuery } from 'academy-common-lib/utils/Styling';
import { ALLOWED_OTG_IDS } from '../../constants/SoftwareDiscoveryConstants';
export const useRequestLearnWhileDoing = create(set => ({
  isLearnWhileDoingScreenEnabled: false,
  isLearnWhileDoingEnabled: false,
  playHsVideo: false,
  isVideoPlayed: false,
  isVideoFinished: false,
  handlePlayHsVideo: () => set(() => ({
    playHsVideo: true
  })),
  handleDisableLearnWhileDoingScreen: () => set(() => ({
    isLearnWhileDoingScreenEnabled: false
  })),
  handleEnableLearnWhileDoingScreen: () => set(() => ({
    isLearnWhileDoingScreenEnabled: true
  })),
  handleDisableLearnWhileDoing: () => set(() => ({
    isLearnWhileDoingEnabled: false
  })),
  handleEnableLearnWhileDoing: () => set(() => ({
    isLearnWhileDoingEnabled: true
  })),
  handleVideoPlayed: flag => set(() => ({
    isVideoPlayed: flag
  })),
  handleVideoFinished: flag => set(() => ({
    isVideoFinished: flag
  }))
}));
export const useLearnByDoing = () => {
  const {
    isLearnWhileDoingScreenEnabled,
    playHsVideo,
    handleEnableLearnWhileDoingScreen,
    handleDisableLearnWhileDoingScreen,
    isLearnWhileDoingEnabled
  } = useRequestLearnWhileDoing();
  const location = useLocation();
  const {
    pathname
  } = location;
  const {
    shortId
  } = useParams();
  const isScreenSizeAccepted = useCustomMediaQuery('(max-width: 1024px)');
  useEffect(() => {
    if (!isScreenSizeAccepted && ALLOWED_OTG_IDS.includes(Number(shortId))) {
      handleEnableLearnWhileDoingScreen();
    } else {
      handleDisableLearnWhileDoingScreen();
    }
  }, [handleDisableLearnWhileDoingScreen, handleEnableLearnWhileDoingScreen, isScreenSizeAccepted, pathname, shortId]);
  const updatedVideoProps = {
    autoPlay: playHsVideo
  };
  return {
    shouldRenderLearnByDoingScreen: isLearnWhileDoingScreenEnabled || isLearnWhileDoingEnabled,
    updatedVideoProps
  };
};